// extracted by mini-css-extract-plugin
module.exports = {"film":"BrandLogoLink_film__qPiW6","link":"BrandLogoLink_link__yx2pR","rotate":"BrandLogoLink_rotate__9ggyt","viewmaster":"BrandLogoLink_viewmaster__8iXY2"};